import {Types} from "@Common/types";
import {BRANCH_LEVEL, COMPANY_LEVEL} from "./logic/user-level";

export const getProfileLabels = ({company, session, userLevels}:Pick<
    Types.Xpresso.Loaders.ContextNameMap,
    "company" | "session" | "userLevels"
>) =>
{
    if (!userLevels || !session.data || !company) {
        return null;
    }
    const profileNameFallback = (
        userLevels?.userLevel === COMPANY_LEVEL ? (
            "Company Admin"
        ) : userLevels?.userLevel === BRANCH_LEVEL ? (
            "Office Admin"
        ) : "Account"
    );
    const orgName = (
        userLevels?.userLevel === COMPANY_LEVEL
        ? company?.companyName
        : session.data?.branch?.branchName || session.data?.branch?.branchLegalName
    );
    return {
        profileName: userLevels?.profileName || profileNameFallback,
        orgName,
    };
};

